import { ApolloClient, createHttpLink, gql, InMemoryCache } from '@apollo/client';
import { Link } from "gatsby";
import moment from "moment/moment";
import React from "react";
import { CategoryColor } from '../utils/CategoryColor';
import { CategoryUtils } from '../utils/CategoryUtils';
// import BookmarkButton from "../components/bookmark-button";
import SharePanel from "../components/share"
import Loading from "../components/loading"
import { SOURCES } from '../utils/sources';


const graphql_query = gql`
query GET_POST($id: ID!) {
  post(id: $id, idType: DATABASE_ID) {
    id
    postId
    title
    excerpt
    uri
    link
    date
    content
    template_file
    categoria_landing_img
    categoria_landing_text
    categoria_landing_link
    video_content
    video_embedded_home
    primary_category
    primary_category_link
    categories_json_array
    featuredImage {
      node {
        link
        guid
        mediaItemUrl
        srcSet
        sizes
      }
    }
    categories {
      nodes {
        id
        name
        slug
      }
    }
    tags {
      nodes {
        id
        slug
        name
      }
    }
    author {
      node {
        name
        avatar(size: 50) {
          url
        }
        slug
        description
      }
    }
    preview {
      node {
        id
        postId
        title
        excerpt
        uri
        link
        date
        content
        template_file
        categoria_landing_img
        categoria_landing_text
        categoria_landing_link
        video_content
        video_embedded_home
        primary_category
        primary_category_link
        categories_json_array
        featuredImage {
          node {
            link
            guid
            mediaItemUrl
            srcSet
            sizes
          }
        }
        categories {
          nodes {
            id
            name
            slug
          }
        }
        tags {
          nodes {
            id
            slug
            name
          }
        }
        author {
          node {
            name
            avatar(size: 50) {
              url
            }
            slug
            description
          }
        }
      }
    }
  }
}
`;


class SavedPost extends React.Component {

  constructor(props) {
    console.warn('props', props);
    super(props);
    this.state = {
      'postUri': this.props.postUri,
      'post': {},
      'isLoading': true,
      'thereAreError': false,
    };
  }

  componentDidMount() {
    this.setState(
      {'isLoading': true},
    );

    this.getData();
  }

  getData() {
    const postUri = this.state.postUri;
    if (!postUri) {
      console.error('Error, no post uri for ', window.location)
      this.setState({
        thereAreParamError: true,
        isLoading: false
      });
      return
    }

    const requestOptions = {
      "credentials": "omit",
      "headers": {
        "accept": "application/json",
        "content-type": "application/json"
      },
      "method": "GET",
      "mode": 'cors'
    };

    fetch(
      `https://admin.startupitalia.eu/wp-json/wpse/v1/url-to-postid?p=${postUri}`,
      requestOptions
    )
    .then(res => res.json())
    .then((data) => {
      const blogName = data?.data?.blog_name;
      const postId = data?.data?.post_id;
      console.log('blogName ', blogName, 'postId', postId);

      if (!blogName || !postId) {
        console.error('Error, no blogName or postId: ', data, this.state)
        this.setState({
          thereAreParamError: true,
          isLoading: false
        });
        return
      }

      let dsources = {};
      SOURCES.forEach(s => {
        dsources[s.key] = s.url;
      })

      var gql_url = 'www';
      try {
        gql_url = dsources[blogName];
      } catch (error) {
        this.setState(
          {
            thereAreParamError: true,
            isLoading: false
          }
        );
        return;
      }

      const httpLink = createHttpLink({
        uri: gql_url,
        // credentials: 'include'
      });

      const client = new ApolloClient({
        // uri: 'https://admin.startupitalia.eu/index.php?graphql',
        link: httpLink,
        cache: new InMemoryCache()
      });

      client.query({query: graphql_query, variables: {id: postId}})
      .then(result => {
        var data = JSON.parse(JSON.stringify(result['data']));
        if (data) {
          if (data['post']?.preview && data['post'].preview.node){
            this.setState({
              'isLoading': false,
              'post': data['post'].preview.node
            });
          } else {
            this.setState({
              'isLoading': false,
              'post': data['post']
            });
          }
        } else {
          this.setState({
            'isLoading': false,
            'thereAreError': true,
            'post': {}
          });
        }
        console.log('state', this.state);
      })
      .catch(err => {
        console.error(err);
      });
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="post-404">
          <SharePanel display="none"/>
          <Loading />
        </div>
      );
    } else if (this.state.thereAreError) {
      console.error('Post not avaiable, incorrect request');
      return (
        // <div style={{width: '100%', textAlign: 'center', paddingTop: '5rem', paddingBottom: '5rem'}}>
        //   <h2>Post not avaiable, incorrect request</h2>
        // </div>
        <div></div>
      )
    } else if (
        !this.state.thereAreParamError &&
        (this.state.post !== {} && this.state.post !== undefined && this.state.post !== null)
        ) {
      return (
        <section key={this.state.postUri} id={"div_"+this.state.postUri}  style={{zIndex: "98", marginBottom: "32px", marginTop: "32px"}}>
          <SharePanel title={'saved_post'} components_name_md5="_saved_post" display="none"/>
          <div className="head-posts-container">
            <div className="head-save-element" >
              <Link className="a_black"  to={this.state.post.uri} >
                <div className="left_save_posts">
                  <div style={{backgroundImage: "url(" + (this.state.post?.featuredImage?.node?.mediaItemUrl || "") + ")" }} className="map_save_posts_imgdiv" ></div>
                  { this.state.post.video_content && !this.state.post.video_embedded_home && (<div style={{background: "linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,0.7))"}} className="map_save_posts_imgdiv"></div> )}
                  { this.state.post.video_content && !this.state.post.video_embedded_home && (<div style={{backgroundImage: "url(/img/sound_anim1.gif)"}} className="map_save_posts_imgdiv_video" ></div>)}
                  { this.state.post.video_content && this.state.post.video_embedded_home && (<div dangerouslySetInnerHTML={{ __html: this.state.post.video_embedded_home }} />  )}
                </div>
              </Link>
              <div className="right_save_posts">
                <div className="group">
                  <div style={{
                    color: '#43BDCC',
                    fontFamily: "urw-din",
                    fontSize: '12px',
                    fontWeight: '500',
                    letterSpacing: '0.48px',
                    lineHeight: '12px',
                    marginTop: '1rem',
                  }} className="floatleft">
                    <Link style = {{color: new CategoryColor(this.state.post.primary_category).color}} to={`${new CategoryUtils(this.state.post.primary_category).link}`}>
                      {this.state.post.primary_category}
                    </Link>
                  </div>
                  <div className="floatright">
                    <button style={{background: 'transparent', padding:"5px" }} onClick={()=>this.props.onClickBookmark(this.state.postUri, this.state.post.title)}>
                      <img
                        alt="Prefered"
                        src={"/img/on@2x.png"}
                        style={{
                          marginTop: "7px",
                          width: "26px",
                          height: "auto"
                        }}
                      />
                    </button>
                    {/* <BookmarkButton
                      onClick={()=>this.props.onClickBookmark(this.state.postUri, this.state.post.title)}
                      news_url={this.state.postUri}
                    /> */}
                  </div>
                </div>
                <Link title={this.state.post.title} to={this.state.postUri}>
                  <div className="saved-post-title" >
                    <h2
                      style={{
                        fontFamily: "aktiv-grotesk",
                        fontSize: '30px',
                        letterSpacing: '-0.43px',
                        lineHeight: '37px',
                      }}
                      >{this.state.post.title}
                    </h2>
                    <div style={{
                      height: '135px',
                      fontFamily: 'urw-din',
                      fontSize: '18px',
                      letterSpacing: '0',
                      lineHeight: '28px',
                      overflow: 'hidden'
                    }} dangerouslySetInnerHTML={{ __html: this.state.post.excerpt }} >
                    </div>
                  </div>
                  <div className="group" style={{
                      color: '#B2B4CA',
                      fontFamily: "urw-din",
                      fontSize: '12px',
                      letterSpacing: '0',
                      lineHeight: '24px',
                      textTransform: 'uppercase'
                    }}>
                    <div className="floatleft">
                      {this.state.post.author?.node?.name}
                    </div>
                    <div style={{marginTop: 'auto'}} className="floatright">
                      {moment(this.state.post.date).format(`MMMM D, YYYY`)}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default SavedPost